<div class="not-found">
  <div class="not-found__shell" aria-labelledby="not-found-title">
    <div class="not-found__header">
      <div class="not-found__mark" aria-hidden="true">
        <ng-glyph name="report" size="28"></ng-glyph>
      </div>
      <div>
        <p class="not-found__eyebrow">Error 404</p>
        <h1 id="not-found-title" class="not-found__title">Page not found</h1>
      </div>
    </div>

    <app-card class="not-found__card" [padded]="false">
      <div class="not-found__content">
        <p class="not-found__desc">
          The address does not match an available page in the admin workspace. The page may have been moved, removed, or entered
          incorrectly.
        </p>

        <div class="not-found__divider"></div>

        <div class="not-found__details" aria-label="Suggested next steps">
          <div class="not-found__detail">
            <ng-glyph name="check_circle" size="20"></ng-glyph>
            <span>Confirm the URL is typed correctly.</span>
          </div>
          <div class="not-found__detail">
            <ng-glyph name="admin_panel_settings" size="20"></ng-glyph>
            <span>Return to the dashboard and use the navigation menu.</span>
          </div>
        </div>

        <div class="not-found__actions" aria-label="Navigation actions">
          <app-button routerLink="/home">
            <ng-glyph name="home" size="20"></ng-glyph>
            Go to dashboard
          </app-button>
          <app-button routerLink="/login" variant="secondary">
            <ng-glyph name="login" size="20"></ng-glyph>
            Go to login
          </app-button>
        </div>
      </div>
    </app-card>
  </div>
</div>
